import React, { useMemo } from 'react';
import { ReactComponent as ErrorImg } from './error.svg';
import styled from 'styled-components';

const Wrap = styled.div`
  text-align: center;
`;
const Text = styled.div`
  font-size: 24px;
  line-height: 34px;
  margin-top: 24px;
`;

export const Error = () => {
  return (
    <Wrap>
      <ErrorImg />
      <Text>
        Ошибка загрузки данных.
        <br /> Мы уже знаем о проблеме.
      </Text>
    </Wrap>
  );
};
